import { render, staticRenderFns } from "./VTwoSectionTitle.vue?vue&type=template&id=166098d4"
import script from "./VTwoSectionTitle.vue?vue&type=script&lang=js"
export * from "./VTwoSectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports